import { render, staticRenderFns } from "./GradientBackground.vue?vue&type=template&id=5701de0b&scoped=true&"
import script from "./GradientBackground.vue?vue&type=script&lang=js&"
export * from "./GradientBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5701de0b",
  null
  
)

export default component.exports